import React, { useState, useEffect } from 'react'
import { FormGroup, ControlLabel, Row, Col, SelectPicker } from 'rsuite'
import classNames from 'classnames'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
// import './styles.less'

export default function SingleDropdownForm({
  schema,
  register,
  error,
  Controller,
  control,
  setValue,
  reset,
  clearErrors,
  onChangeValue,
  ...props
}) {
  const { searchable } = props
  // const [schema, setSchema] = useState(_schema)
  const [seletedValue, setSeletedValue] = useState(schema.value)

  setValue(schema.name, seletedValue)

  return (
    <>
      {schema && (
        <FormGroup>
          <Row>
            <Col xs={24} sm={12} md={8} lg={7}>
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(schema.validators) && 'required'
                )}
              >
                {schema.label}
              </ControlLabel>
              <ErrorMessage error={error} />
              <Controller
                key={schema.name}
                name={schema.name}
                control={control}
                rules={isValidators(schema.validators)}
                defaultValue={seletedValue}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={schema.options}
                      // value={seletedValue}
                      value={props.value}
                      style={{ marginTop: '3px', width: '100%' }}
                      searchable={searchable || false}
                      placeholder="เลือก"
                      onChange={(value) => {
                        props.onChange(value)
                        setSeletedValue(value)
                        onChangeValue(value)
                      }}
                      disabled={schema.disabled}
                    />
                  )
                }}
              />
            </Col>
          </Row>
        </FormGroup>
      )}
    </>
  )
}
